'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var any = exports.any = function any() {
  return true;
};

var final = exports.final = function final(value, listenable) {
  return !listenable._isInitialized;
};

var boolean = exports.boolean = function boolean(value) {
  return typeof value === 'boolean';
};

var string = exports.string = function string(value) {
  return typeof value === 'string' && !!value;
};

var number = exports.number = function number(value) {
  return typeof value === 'number';
};

var symbol = exports.symbol = function symbol(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'symbol';
};

var func = exports.func = function func(value) {
  return typeof value === 'function';
};

var object = exports.object = function object(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null;
};

var undef = exports.undef = function undef(value) {
  return typeof value === 'undefined';
};

var array = exports.array = function array(value) {
  return Array.isArray(value);
};

var possiblyEmptyString = exports.possiblyEmptyString = function possiblyEmptyString(value) {
  return typeof value === 'string';
};

var nullableObject = exports.nullableObject = function nullableObject(value) {
  return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
};

var integer = exports.integer = function integer(value) {
  return Number.isInteger(value);
};

var parsableInteger = exports.parsableInteger = function parsableInteger(value) {
  return Number.isInteger(Number.parseFloat(value, 10));
};

var parsableNumber = exports.parsableNumber = function parsableNumber(value) {
  return !Number.isNaN(Number.parseFloat(value, 10));
}; // Takes arguments


var undefOr = exports.undefOr = function undefOr(validator) {
  return function (value, l, p) {
    return undef(value) || validator(value);
  };
};

var oneOf = exports.oneOf = function oneOf(possibleValues) {
  return function (value) {
    return possibleValues.indexOf(value) !== -1;
  };
};

var oneOfType = exports.oneOfType = function oneOfType(possibleTypes) {
  return function (value) {
    return possibleTypes.some(function (type) {
      return type(value);
    });
  };
};

var arrayOf = exports.arrayOf = function arrayOf(validator) {
  return function (value, l, p) {
    return array(value) && value.every(function (v) {
      return validator(v, l, p);
    });
  };
};

var objectOf = exports.objectOf = function objectOf(validator) {
  return function (value, l, p) {
    return object(value) && Object.keys(value).map(function (key) {
      return value[key];
    }).every(function (v) {
      return validator(v, l, p);
    });
  };
};

var shape = exports.shape = function shape(obj) {
  return function (value) {
    return value && Object.keys(obj).every(function (key) {
      return obj[key](value[key]);
    });
  };
};

var exactShape = exports.exactShape = function exactShape(obj) {
  return function (value) {
    return shape(obj)(value) && Object.keys(value).every(function (key) {
      return Object.keys(obj).indexOf(key) !== -1;
    });
  };
};